import { render, staticRenderFns } from "./ServicesSlider.vue?vue&type=template&id=01ceac06&"
import script from "./ServicesSlider.vue?vue&type=script&lang=js&"
export * from "./ServicesSlider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports